import Swiper from 'swiper/dist/js/swiper';
import { animationDuration } from 'javascripts/utils/testing';

document.addEventListener('DOMContentLoaded', () => {
  Swiper.defaults.speed = animationDuration(300);
});
